import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useEffect, useRef } from 'react'

import classNames from '../../utils/classNames'
import closeModal from '../../utils/closeModal'
import { getBrowserName } from '../../utils/getBrowserName'
import Icon from '../icon'
import Modal from './modal'

const browserName = getBrowserName()

const PWATutorial = ({
  pwa_tutorial,
  onEndedCallback,
  withManualDownload,
}: {
  pwa_tutorial: string
  onEndedCallback?: () => void
  withManualDownload?: boolean
}) => {
  const modal = useModal()
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    const handleEnded = () => {
      closeModal(modal)
      onEndedCallback?.()
    }

    // Add event listeners
    video.addEventListener('ended', handleEnded)

    // Cleanup
    return () => {
      video.removeEventListener('ended', handleEnded)
    }
  }, [onEndedCallback])

  return (
    <Modal
      id="pwa-tutorial"
      hideOverlay
      isFullScreen
      containerStyle="!px-0 !py-0 !mx-0 !my-0 !bg-black !border-none !shadow-none">
      <button
        className="absolute top-2 left-2 z-10 bg-gray-600 bg-opacity-50 p-3 rounded-full"
        onClick={() => closeModal(modal)}>
        <Icon className="w-4 h-4 fill-white" id="close" />
      </button>
      {withManualDownload && (
        <button
          className="absolute top-[60px] left-2 z-10 bg-gray-600 bg-opacity-50 p-2 rounded-full"
          onClick={() => onEndedCallback?.()}>
          <Icon className="w-6 h-6 fill-white" id="download" />
        </button>
      )}
      <video
        ref={videoRef}
        preload="auto"
        playsInline
        controls
        autoPlay
        muted={browserName === 'opera'}
        className={classNames(
          'relative bottom-0 mx-auto w-auto',
          browserName === 'safari' ? 'h-[calc(100%-60px)] mt-[60px]' : 'h-full',
        )}>
        <source src={pwa_tutorial} type="video/mp4" />
      </video>
    </Modal>
  )
}

export default NiceModal.create(PWATutorial)
